/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fc-today-button[_ngcontent-%COMP%]{display:none!important;opacity:0!important}"];
export { styles as styles };
